export default "__VITE_ASSET__056770f2__"